var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2a.5.5 0 01.5-.5H3a3.5 3.5 0 013.474 3.077l.051-.052A3.5 3.5 0 019 3.5h1.5a.5.5 0 01.5.5v.5A3.5 3.5 0 017.5 8h-1v2a.5.5 0 01-1 0V6.5h-1A3.5 3.5 0 011 3V2zm4.5 3.5h-1A2.5 2.5 0 012 3v-.5h1A2.5 2.5 0 015.5 5v.5zm1 1.5h1A2.5 2.5 0 0010 4.5H9A2.5 2.5 0 006.5 7z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--plant-404d29e17704c1ea99cbcb020d4ae7a1.svg";
export { SvgIconUiPlant as Component };